import VirtualSportPageView from './virtual-sport-page-view/index.js';
import { useSelector } from 'react-redux';
import MojitoServices from 'mojito/services';
import MojitoPresentation from 'mojito/presentation';

const { useLocalizedParams } = MojitoPresentation.Hooks;
const { selectItems: selectContainerItems } = MojitoServices.SportsContent.ContainerItems.selectors;

export default function VirtualSportPage(props) {
    const { sportId, classId, eventId } = useLocalizedParams();
    const { config } = props.mojitoTools;
    const { containerId } = config.virtualsEndpoint;
    const sportInfo = useSelector(state => {
        const virtualSports = selectContainerItems(containerId, state);
        return virtualSports?.find(({ id }) => id === sportId);
    });
    return (
        <VirtualSportPageView
            sportId={sportId}
            sportInfo={sportInfo}
            classId={classId}
            selectedEventId={eventId}
        />
    );
}
